const bg_colors = {
    "gray": "bg-gray-500 text-black",
    "green":"bg-[#6AAA64] text-white",
    "gold":"bg-[#C9B458] text-white",
    "empty":"bg-[#D3D6DA] text-black",
}

export default function KeyboardRow({row, yellowCharacters, greenCharacters, greyCharacters,handleKeyUp}) {
    return (
        <div className="flex gap-2">
            {row.map((item,i)=>{
                let x = "empty"
                if (yellowCharacters.has(item)){
                    x = "gold"
                } else if (greenCharacters.has(item)){
                    x = "green"
                } else if (greyCharacters.has(item)){
                    console.log("I am in here in the gray characters")
                    x = "gray"
                    console.log(bg_colors["gray"])
                }
                return (
                    <div style={{
                        transitionDelay:"3000ms"
                    }} className={` cursor-pointer uppercase text-2xl flex justify-center items-center h-[60px] min-w-[50px] border border-gray-200 px-3 py-2 rounded-md ${bg_colors[x]} `} key={i} onClick={(e)=>{handleKeyUp({key:item})}}>
                        {item}
                    </div>
                )
            })}
        </div>
    )
}